export const REQUEST_REVIEW_AFTER_COURSE_START_EVENT =
  'event:request_review_after_course_start';
